module.exports = __webpack_public_path__ + "img/angpao.e74ef1d4.png";